export default __webpack_public_path__ + "static/media/fastclix_lancing_kit@3x.c55b023e.png";